import { FormStep, SelectedExperienceType } from '../types';

export function haveAllExperiencesBeenSelected({
  selectableExperiencesByDay,
  selectedExperiences,
  totalGuests,
  numberOfSelections,
}: {
  selectableExperiencesByDay: FormStep['selectExperienceOptionsByDayNumber'];
  selectedExperiences: SelectedExperienceType[] | undefined;
  totalGuests: number;
  numberOfSelections: number;
}) {
  const totalIncludedExperiences = (selectedExperiences || []).filter(
    (exp) => exp.isIncluded
  ).length;

  const totalSelectableExperiences = (selectableExperiencesByDay || []).flatMap(
    (exp) => exp.options
  ).length;

  const totalRequiredSelections =
    totalIncludedExperiences * totalGuests + totalSelectableExperiences * totalGuests;

  return numberOfSelections === totalRequiredSelections;
}
